var calendar = null;
/**
 * Find the requested GET param
 * @param  {string} parameterName The name of the parameter
 * @return {string}               The value
 * @link  https://stackoverflow.com/a/5448595
 */
function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    var items = location.search.substr(1).split("&");
    for (var index = 0; index < items.length; index++) {
        tmp = items[index].split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
    return result;
};
/**
 * Load the calendar
 * @return {Void}
 */
function loadCalendar() {
  var calendarEl = document.getElementById('calendar');

  calendar = new FullCalendar.Calendar(calendarEl, {
    plugins: [ 'interaction', 'dayGrid' ],
    contentHeight: 'auto',
    editable: false,
    eventOverlap: false,
    selectable: true,
    selectOverlap: false,
    eventLimit: true,
    eventColor: '#b00e00',
    events: function(info, successCallback, failureCallback) {
      var cacheBreaker = Math.random().toString(36).substring(7);
      $.ajax({
        url: '/fasting/dates?breaker='+cacheBreaker
      })
      .done(function(data) {
        var events = [];
        if (data['dates'].length === 0) {
          /**
           * We cleared the calendar, so empty their dates.
           */
          window.localStorage.setItem('fasting_days', JSON.stringify([]));
        }
        var myDates = [];
        if (hasStorage()) {
          var fasting = window.localStorage.getItem('fasting_days');
          if (fasting) {
            myDates = JSON.parse(fasting);
          }
        }
        for (var i = 0; i < data['dates'].length; i++) {
          if (moment(data['dates'][i]).isBetween(info.start, info.end)) {
            var anEvent = {
              title: 'Filled',
              start: data['dates'][i],
              allDay: true
            };
            if (myDates.indexOf(moment(data['dates'][i]).format('YYYY-MM-DD')) > -1) {
              anEvent['color'] = '#019245';
            }
            events.push(anEvent);
          }
        }
        successCallback(events);
      })
      .fail(function() {
        failureCallback([]);
      });
    },
    select: function(info) {
      var start = moment(info.start);
      var end = moment(info.end);
      var oneDayBeforeEnd = moment(info.end).subtract(24, 'hours');
      var message = '';
      var dates = [];
      if (start.isSame(oneDayBeforeEnd)) {
        message = '<p>Are you willing to fast on <strong>'+start.format('ddd. MMM. Do YYYY')+'</strong>?</p>';
        dates.push(start.format('YYYY-MM-DD'));
      } else {
        message = '<p>Are you willing to fast on?<ul>';
        for (var m = start; m.isBefore(end); m.add(1, 'days')) {
          message += '<li>'+m.format('ddd. MMM. Do YYYY')+'</li>';
          dates.push(m.format('YYYY-MM-DD'));
        }
        message += '</ul>';
      }
      $('#dateConfirm .modal-body').html(message);
      $('#saveDates').attr('data-dates', dates.join('|'));
      $('#dateConfirm').modal('show');
    },
    validRange: function(nowDate) {
      return { start: nowDate };
    }
  });

  calendar.render();
};
/**
 * Check if they have local storage
 *
 * @return {Boolean} Yes|No
 */
function hasStorage() {
  return (typeof(Storage) !== 'undefined');
};
/**
 * Save the dates in local storage.
 *
 * @param  {string} dates A pipe seperated string of dates.
 *
 * @return {boolean}      Successful?
 */
function saveDates(dates) {
  if (!hasStorage()) {
    return false;
  }
  var current = window.localStorage.getItem('fasting_days');
  var currentDecoded = [];
  if (current) {
    currentDecoded = JSON.parse(current);
  }
  var newDates = dates.split('|');
  for (var i = 0; i < newDates.length; i++) {
    if (currentDecoded.indexOf(newDates[i]) === -1) {
      currentDecoded.push(newDates[i]);
    }
  }
  /**
   * Let's clean up old dates.
   *
   */
  var upcoming = [];
  var yesterday = moment().subtract(1, 'days');
  for (var i = 0; i < currentDecoded.length; i++) {
    if (moment(currentDecoded[i]).isAfter(yesterday)) {
      upcoming.push(currentDecoded[i]);
    }
  }
  window.localStorage.setItem('fasting_days', JSON.stringify(upcoming));
  return true;
};

$(document).ready(function() {
  var isApp = findGetParameter('app');
  if (isApp && (isApp === 'true')) {
    $('.navbar').hide();
    $('body').css('padding-top', 0);
  }
  loadCalendar();
  $('#dateConfirm').on('click', '#saveDates', function(event) {
    event.preventDefault();
    var dates = $(this).attr('data-dates');
    if (dates) {
      $.ajax({
        url: '/fasting/dates',
        type: 'POST',
        data: {dates: dates.split('|')}
      })
      .done(function() {
        saveDates(dates);
        calendar.refetchEvents();
        $('#dateConfirm').modal('hide');
      })
      .fail(function() {
        console.error('Error saving dates.');
      });
    }
  });
});
